export const SET_BB_READY = 'SET_BB_READY'

const setBBReady = (bbReady) => {
    return (dispatch) => {
        dispatch({
            type: SET_BB_READY,
            bbReady
        })
    }
}

export { setBBReady }